// extracted by mini-css-extract-plugin
export default {"container":"zaiaIntegration_container__48ZcD","actions":"zaiaIntegration_actions__nhsZk"};